import React, { useState, useMemo } from 'react';
import { Box, Container, IconButton, useTheme } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { useSelector } from 'react-redux';
import PageNavbar from '../PageNavbar';
import PageSidebar from '../PageSidebar';
import { PageLayoutRoot } from './styles';
import { getSidebarItems, getSideBarMenuRoutes } from '../SideBarMenuRoutes';

const PageLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
    const theme = useTheme();
    const currentUser = useSelector((state) => state.session.user);

    const menuItems = useMemo(
        () =>
            getSidebarItems(
                currentUser?.authorities || [],
                { isClientHqEnabled: currentUser?.isClientHqEnabled },
                getSideBarMenuRoutes({ isClientHqEnabled: currentUser?.isClientHqEnabled }),
            ),
        [currentUser?.authorities],
    );

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    return (
        <Box style={{ width: '100vw', height: '100vh' }}>
            <Box style={{ width: '100%', height: '64px' }}>
                <PageNavbar />
            </Box>
            <Box style={{ width: '100%', height: 'calc(100% - 64px)' }}>
                {menuItems.length <= 1 ? (
                    <Box
                        style={{
                            width: '100%',
                            height: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            background: '#EDF3FA',
                            padding: '40px',
                            flexShrink: 0,
                            boxSizing: 'border-box',
                            overflowX: 'hidden',
                        }}
                    >
                        <Container maxWidth="100%">{children}</Container>
                    </Box>
                ) : (
                    <Box style={{ width: '100%', height: '100%', display: 'flex' }}>
                        <Box
                            style={{
                                width: collapsed ? '60px' : '250px',
                                flexShrink: 0,
                                boxSizing: 'border-box',
                                overflowX: 'hidden',
                                transition: 'width 0.3s',
                                backgroundColor:
                                    theme.palette.mode === 'light'
                                        ? theme.palette.neutral[50]
                                        : theme.palette.neutral[900],
                            }}
                        >
                            <PageSidebar collapsed={collapsed} />
                        </Box>
                        <Box width={'0px'}>
                            <IconButton
                                onClick={toggleSidebar}
                                sx={{
                                    top: 44,
                                    width: '26px',
                                    height: '26px',
                                    marginLeft: '-13px',
                                    zIndex: 1200,
                                    boxShadow: 1,
                                    borderRadius: '50%',
                                    transition: 'left 0.3s',
                                    backgroundColor: 'background.paper',
                                    '&:hover': {
                                        backgroundColor: 'primary.light',
                                    },
                                }}
                            >
                                {collapsed ? <ChevronRight /> : <ChevronLeft />}
                            </IconButton>
                        </Box>
                        <PageLayoutRoot collapsed={collapsed}>
                            <Container maxWidth="100%">{children}</Container>
                        </PageLayoutRoot>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default PageLayout;
